// IMPORT REACT
import React from 'react';

// IMPORT COMPONENTS
import YAIcon from '../../Icon';
import YAText from '../../Text';

// IMPORT STYLES
import { SC_ButtonInternal, SC_ButtonExternal, SC_ButtonFunctional } from '../styles';

const identifyComponent = (props) => {
  if(props.href){
    return SC_ButtonExternal;
  } else if(props.onClick){
    return SC_ButtonFunctional;
  }
  return SC_ButtonInternal;
}

const YAButton = (props) => {

  let Template = identifyComponent(props);
  
  // let mailto = props.to[0].substring(0, 7) == "mailto:";
    return (
    	<Template 
        to={props.href ? null : props.to} 
        href={props.href} 
        target={props.href ? "_blank" : null}
        icon={props.icon} 
        className={['btn-' + props.color, props.bootstrap, 'btn-' + props.size]}
        block={props.block} 
        {...props}
        icononly={props.children ? 0 : 1}
        disabled={props.disabled}
      >
        {props.icon ? <YAIcon icon={props.icon} fillYiq={props.iconColor ? props.iconColor : props.color} height="50px" rotate={props.icon == 'caret' && props.collapseOpen ? '180deg' : null} /> : null}
        <YAText tag="span">{props.children}</YAText>
      </Template>
    )
    
}
export default YAButton;